import { Button } from './ui/components'

interface CardInfoSelectMemberProps {
  backToStudents: () => void
}

export function CardInfoSelectMember({ backToStudents }: CardInfoSelectMemberProps) {
  return (
    <div className="flex gap-4 flex-col items-center justify-center h-[calc(100vh-300px)]">
      <div className="p-12 shadow-md rounded-md flex flex-col items-center justify-center gap-4">
        <h3 className="font-bold text-2xl">Para exibir selecione um aluno.</h3>
        <Button onClick={backToStudents} variant={'default'} className="bg-acelerafit-green-400 text-muted hover:bg-acelerafit-green-200">
          Ir para a seleção de aluno
        </Button>
      </div>
    </div>
  )
}
